<template>
  <div class="result-page">
    <div class="banner">
      <img src="@/assets/images/greenpark.jpg">
    </div>
    <!--<div class="iframe-box">
      <iframe src="//www.minhngoc.net.vn/" frameborder="0" scrolling="no"></iframe>
    </div>
    <div class="banner">
      <img src="@/assets/images/banner4.jpg">
    </div>-->
    <ResultBox />
    <div class="banner">
      <a href="https://xosoredcross.com/" target="_blank">
        <img src="@/assets/images/redcross550x450.png">
      </a>
    </div>
    <div class="banner">
      <img src="@/assets/images/tai-app-415x315.jpg">
    </div>
    <!-- <div class="news">
      <iframe class="iframe-1" src="//www.minhngoc.net.vn/" frameborder="0" scrolling="no"></iframe>
    </div> -->
    <div class="banner">
      <a href="https://xosoextra.com/" target="_blank">
        <img src="@/assets/images/extra550x450.png">
      </a>
    </div>
    <div class="banner">
      <img src="@/assets/images/lichphatsong-1597510677441.jpg">
    </div>
  </div>
</template>
<script>
import ResultBox from './components/ResultBox.vue'

export default {
  components: {
    ResultBox
  },
  data() {
    return {
      currentDate: null
    }
  },
  created() {
    console.log('pathDate', this.$route.params.pathDate)
  }
}
</script>
<style lang="scss">
.my-result {
  height: 450px;
  margin-bottom: 10px;
}
.banner {
  margin-top: 10px;
  img {
    width: 100%;
  }
}
</style>
<style lang="scss" scoped>
.news {
  overflow: hidden;
  //margin-top: 10px;
  padding: 0px 5px;
  border: 1px solid #BBB;
  border-radius: 5px;
  margin-bottom: 10px;

  .iframe-1 {
    overflow: hidden;
    height: 1240px !important;
    margin-left: -215px;
    margin-top: -520px;
    width: 740px;
    max-width: none;
  }
}
.iframe-box {
  overflow: hidden;
  padding: 0px 5px;
  border: 1px solid #BBB;
  border-radius: 5px;
  margin-bottom: 10px;
  iframe {
    margin-left: -222px !important;
    margin-top: -185px !important;
    height: 410px !important;
    width: 733px !important;
    pointer-events: none;
  }
}

@media screen and (max-width: 600px) {
  .result-page {
    padding: 0 5px;
  }
  .iframe-box {
    margin-top: 10px;
  }
}
</style>
